
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import { useSubscriptionManagement } from '@/hooks/useSubscriptionManagement';
import SubscriptionsTable from '@/components/superadmin/SubscriptionsTable';
import OnboardingDetailsDialog from '@/components/superadmin/OnboardingDetailsDialog';
import SubscriptionSearchBar from '@/components/superadmin/SubscriptionSearchBar';

const SuperAdminSubscriptions = () => {
  const {
    isLoading,
    user,
    filteredSubscriptions,
    searchQuery,
    selectedSubscription,
    onboardingDialogOpen,
    handleLogout,
    handleSearch,
    handleViewOnboarding,
    handleSendTrialReminder,
    setOnboardingDialogOpen
  } = useSubscriptionManagement();

  return (
    <SuperAdminLayout 
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole="superadmin"
      activeTab="subscriptions"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Subscriptions</h1>
            <p className="text-gray-600">Manage customer subscriptions and plans</p>
          </div>
        </div>
        
        <Card className="mb-8">
          <CardHeader className="flex flex-row items-center justify-between">
            <div>
              <CardTitle>Subscription Management</CardTitle>
              <CardDescription>All customer subscriptions and their payment status</CardDescription>
            </div>
            <SubscriptionSearchBar 
              searchQuery={searchQuery}
              onSearch={handleSearch}
            />
          </CardHeader>
          <CardContent>
            <SubscriptionsTable 
              subscriptions={filteredSubscriptions}
              onViewOnboarding={handleViewOnboarding}
              onSendTrialReminder={handleSendTrialReminder}
            />
          </CardContent>
        </Card>
        
        <OnboardingDetailsDialog 
          open={onboardingDialogOpen}
          onOpenChange={setOnboardingDialogOpen}
          subscription={selectedSubscription}
        />
      </div>
    </SuperAdminLayout>
  );
};

export default SuperAdminSubscriptions;
